"use client";

import React from "react";
import Link from "next/link";
import { currentLanguage } from "@/store/useAuthStore";
import { usePathname } from "next/navigation";

type CustomLink = {
  children: React.ReactNode;
  href: string;
  className?: string;
  prefetch?: boolean;
  target?: string;
};
const CustomNavLink = ({
  children,
  href,
  className,
  prefetch = true,
  target = "_self",
}: CustomLink) => {
  const pathname = usePathname();

  const language = pathname.split("/")[1];
  const newlink = `/${language}/${href}`;
  return (
    <Link
      href={newlink}
      className={`${(className && className) || ""}`}
      prefetch={prefetch}
      target={target}
    >
      {children}
    </Link>
  );
};

export default CustomNavLink;
